import {type AttributesRow} from 'platform/components';
import {type CurrencyFormatter} from 'platform/locale';

import {isNotNil} from 'ramda';

import {type PkwEnvkvCalculation} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {type Nullish} from 'shared/web';

import {formatEnvkvCurrency} from './formatEnvkvCurrency';

// CO₂ costs are shown to the cent; the provider sends up to three decimal places.
const CO2_COST_FRACTION_DIGITS = 2;

// The provider reports a tax it did not calculate as 0, so zero is not shown as an amount.
const formatAnnualTax = (formatCurrency: CurrencyFormatter, annualTax: string | Nullish) => {
  const formatted = formatEnvkvCurrency(formatCurrency, annualTax);

  return isNotNil(formatted) && Number(annualTax) === 0
    ? i18n.t('page.pkwEnvkv.labels.taxNotCalculated')
    : formatted;
};

export const getPkwEnvkvCalculationRows = (
  calculation: PkwEnvkvCalculation | Nullish,
  formatCurrency: CurrencyFormatter
): AttributesRow[] => [
  {
    label: i18n.t('page.pkwEnvkv.labels.primaryFuelPrice'),
    value: formatEnvkvCurrency(formatCurrency, calculation?.primaryFuelPrice),
  },
  {
    label: i18n.t('page.pkwEnvkv.labels.annualFuelCost'),
    value: formatEnvkvCurrency(formatCurrency, calculation?.annualFuelCost),
  },
  {
    label: i18n.t('page.pkwEnvkv.labels.annualTax'),
    value: formatAnnualTax(formatCurrency, calculation?.annualTax),
  },
  {
    label: i18n.t('page.pkwEnvkv.labels.co2LowCost'),
    value: formatEnvkvCurrency(formatCurrency, calculation?.co2LowCost, CO2_COST_FRACTION_DIGITS),
  },
  {
    label: i18n.t('page.pkwEnvkv.labels.co2MidCost'),
    value: formatEnvkvCurrency(formatCurrency, calculation?.co2MidCost, CO2_COST_FRACTION_DIGITS),
  },
  {
    label: i18n.t('page.pkwEnvkv.labels.co2HighCost'),
    value: formatEnvkvCurrency(formatCurrency, calculation?.co2HighCost, CO2_COST_FRACTION_DIGITS),
  },
];
